module.exports = new __parcel__URL__("throne.7f39d510.webp").toString();